/**
 * Created by rhillion on 01/07/2017.
 */
import React, {Component} from 'react'
import './MainMenu.css'

export default class ListFilters extends Component {
    state = {}

    render() {

        return (
            <div className="">
                Filters
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ListFilters.js